module.exports = __webpack_public_path__ + "static/Product_Workshops_with_the_team-9e80f10a956b23fd6f6fc0ef21a557f4.png";